import { ErrorPageContainer } from "./error-page-container";
export { ErrorPageRenderer } from "./error-page-renderer";
export default ErrorPageContainer;
